module.exports = __webpack_public_path__ + "img/HIW-PRICE-2-m.214758d1.png";